import { render, staticRenderFns } from "./positionList.vue?vue&type=template&id=c0f874fe&scoped=true&"
import script from "./positionList.vue?vue&type=script&lang=js&"
export * from "./positionList.vue?vue&type=script&lang=js&"
import style0 from "./positionList.vue?vue&type=style&index=0&id=c0f874fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f874fe",
  null
  
)

export default component.exports